module.exports = __webpack_public_path__ + "static/media/flag.a229b70b.svg";